"use strict";var e=require("react"),a=require("styled-components"),o=require("@vds-core/utilities"),n=require("@vds-tokens/color"),r=require("@vds-tokens/typography"),t=require("@vds-core/typography");function l(e){return e&&e.__esModule?e:{default:e}}var i=l(e),d=l(a);const s=(e,a,o)=>{switch(e){case 1:return"dark"===a?n.ColorTokens.elements.secondary[o?"onlight":"ondark"].value:n.ColorTokens.elements.secondary[o?"ondark":"onlight"].value;case 2:return"none;";case 3:return"dark"===a?`linear-gradient(180deg, transparent 50%, ${n.ColorTokens.elements.secondary[o?"onlight":"ondark"].value} 50%);`:`linear-gradient(180deg, transparent 50%, ${n.ColorTokens.elements.secondary[o?"ondark":"onlight"].value} 50%);`}},c=d.default.div.withConfig({displayName:"StyledIndicatorWrapper",componentId:"VDS__sc-1rv4zlm-0"})`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  transform: translate(-50%, -50%);
  height: ${o.calculateRem(10)};
  padding-top: ${o.calculateRem(2)};
`,u=d.default.div.withConfig({displayName:"IndicatorOverallWrapper",componentId:"VDS__sc-1rv4zlm-1"})`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`,p=d.default.span.withConfig({displayName:"Indicator",componentId:"VDS__sc-1rv4zlm-2"})`
  border: ${({surface:e,isSelected:a})=>"dark"===e?`${o.calculateRem(1)} solid ${n.ColorTokens.elements.secondary[a?"onlight":"ondark"].value}`:`${o.calculateRem(1)} solid ${n.ColorTokens.elements.secondary[a?"ondark":"onlight"].value}`};
  background: ${({type:e,surface:a,isSelected:o})=>s(e,a,o)};
  box-sizing: border-box;
  height: ${o.calculateRem(8)};
  width: ${o.calculateRem(8)};
  border-radius: 50%;
  margin: 0 ${o.calculateRem(1)};
  display: inline-block;
`,m=d.default.div.withConfig({displayName:"LegendWrapper",componentId:"VDS__sc-1rv4zlm-3"})`
  padding: 0 ${o.calculateRem(14)};
  max-width: 100%;
  max-height: 100%;
  box-sizing: border-box;
  line-height: 1.15;
  > span:last-child {
    padding-right: 0;
  }
`,g=d.default.span.withConfig({displayName:"Legend",componentId:"VDS__sc-1rv4zlm-4"})`
  padding-right: ${o.calculateRem(16)};
  max-width: 100%;
  overflow-x: hidden;
  white-space: nowrap;
  box-sizing: border-box;
  color: ${({surface:e})=>"dark"===e?n.ColorTokens.elements.primary.ondark.value:n.ColorTokens.elements.primary.onlight.value};
  box-sizing: content-box;
  font-size: ${o.calculateRem(r.TypographyTokens.fontsize.body[12].value)};
  font-family: ${t.Fonts.VerizonNHGeTX};
  font-weight: ${r.TypographyTokens.fontweight.regular.value};
  //line-height: ${o.calculateRem(r.TypographyTokens.lineheight.body[16].value)};
  span {
    white-space: normal;
  }
  &:before {
    content: '';
    border: ${({surface:e})=>"dark"===e?`${o.calculateRem(1)} solid ${n.ColorTokens.elements.secondary.ondark.value}`:`${o.calculateRem(1)} solid ${n.ColorTokens.elements.secondary.onlight.value}`};
    background: ${({type:e,surface:a})=>s(e,a)};
    box-sizing: border-box;
    height: ${o.calculateRem(8)};
    width: ${o.calculateRem(8)};
    border-radius: 50%;
    margin-right: ${o.calculateRem(8)};
    display: inline-block;
  }
`,h=d.default.div.withConfig({displayName:"LegendContainer",componentId:"VDS__sc-1rv4zlm-5"})`
  display: flex;
  align-items: flex-end;
  height: ${o.calculateRem(36)};
  overflow-y: hidden;
  padding-top: ${o.calculateRem(4)};
`;exports.Indicator=p,exports.IndicatorWrapper=e=>i.default.createElement(u,null,i.default.createElement(c,null,e.children)),exports.Legend=g,exports.LegendContainer=h,exports.LegendWrapper=m;



//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/calendars/cjs/components/Indicators.js
// module id = 501
// module chunks = 0